const benefitFavoriteButtonRed = "/images/heart-red.svg"
const benefitFavoriteButtonWhite = "/images/heart.svg"
const benefitFavoriteButtonClass = ".benefit-favorite-button"
const benefitFavoriteFeedClass = ".benefit-favorite-feed"
const benefitFavoriteImageClass = ".benefit-favorite-image"
const benefitFavoriteTextClass = ".benefit-favorite-text"
const apiBenefitEndpoint = "/meine-vorteile/favorite?urlFriendlyTitle="

const useState = (initialValue) => {
    let value = initialValue
    function setValue(newValue) {
        value = newValue
        return value
    }
    return [() => value, setValue]
}

const createFavoriteButton = (favoriteButtonElement) => {
    // Get all the values from the data attributes from "benefit-favorite-button"
    const {
        urlFriendlyTitle,
        csrfToken,
        csrfParameterName,
        isFavoriteText,
        isNotFavoriteText
    } = favoriteButtonElement.dataset
    const isAllowDislikeOnly =
        favoriteButtonElement.dataset.allowDislikeOnly === "true"
    const [isFavorite, setIsFavorite] = useState(
        favoriteButtonElement.dataset.favorite === "true"
    )

    const [isLoading, setIsLoading] = useState(false)

    const favoriteImageElement = favoriteButtonElement.querySelector(
        benefitFavoriteImageClass
    ) // Get benefit-favorite-image element
    const favoriteTextElement = favoriteButtonElement.querySelector(
        benefitFavoriteTextClass
    ) // Get benefit-favorite text element

    // Optimistic UI update: updates UI before the server request completes
    const renderFavoriteState = (newIsFavorite) => {
        if (!isAllowDislikeOnly) {
            favoriteImageElement.src = newIsFavorite
                ? benefitFavoriteButtonRed
                : benefitFavoriteButtonWhite
            const newFavoriteText = newIsFavorite
                ? isFavoriteText
                : isNotFavoriteText
            if (favoriteTextElement) {
                favoriteTextElement.innerHTML = newFavoriteText
            }
            favoriteButtonElement.setAttribute("aria-label", newFavoriteText)
        } else {
            // Special handling when only "dislike" is allowed
            const feedContainer = favoriteButtonElement.closest(
                benefitFavoriteFeedClass
            )
            if (newIsFavorite) {
                feedContainer.style.opacity = 1
                setTimeout(() => {
                    feedContainer.style.display = "block"
                    updateFeedBorders()
                }, 500)
            } else {
                feedContainer.style.opacity = 0
                setTimeout(() => {
                    feedContainer.style.display = "none"
                    updateFeedBorders()
                }, 500)
            }
        }
    }

    // Send an API request to update the favorite status and applies an optimistic update
    const optimisticUpdate = async (newIsFavorite) => {
        const currentIsFavorite = isFavorite() // Store current state in case of failure
        setIsFavorite(newIsFavorite)
        renderFavoriteState(newIsFavorite)

        try {
            const formData = new FormData()
            formData.append(csrfParameterName, csrfToken)

            const response = await fetch(
                `${apiBenefitEndpoint}${urlFriendlyTitle}`,
                {
                    method: newIsFavorite ? "POST" : "DELETE",
                    body: formData
                }
            )

            if (!response.ok) throw new Error("Request failed")
        } catch (error) {
            // Revert optimistic update
            setIsFavorite(currentIsFavorite)
            renderFavoriteState(currentIsFavorite)
        } finally {
            // Finally, allow user to click again
            setIsLoading(false)
        }
    }

    renderFavoriteState(isFavorite())

    const handleToggle = async (event) => {
        event.stopPropagation()
        if (isLoading()) return // Prevent multiple clicks while loading

        // Animation when favoriting
        if (!isFavorite()) {
            favoriteImageElement.style.transform = "scale(1.5)"
            setTimeout(
                () => (favoriteImageElement.style.transform = "scale(1)"),
                250
            )
        }

        setIsLoading(true)
        await optimisticUpdate(!isFavorite()) // Perform optimistic update
    }

    // Hover handlers
    const handleMouseOver = () => {
        if (!isFavorite()) {
            favoriteImageElement.src = benefitFavoriteButtonRed
        }
    }

    const handleMouseOut = () => {
        if (!isFavorite()) {
            favoriteImageElement.src = benefitFavoriteButtonWhite
        }
    }

    favoriteButtonElement.addEventListener("click", (event) =>
        handleToggle(event)
    )
    favoriteButtonElement.addEventListener("mouseover", handleMouseOver)
    favoriteButtonElement.addEventListener("mouseout", handleMouseOut)
    favoriteButtonElement.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
            handleToggle(event)
        }
    })
}

const updateFeedBorders = () => {
    const feedItems = document.querySelectorAll(benefitFavoriteFeedClass)
    let visibleItems = Array.from(feedItems).filter(
        (item) => window.getComputedStyle(item).display !== "none"
    )

    visibleItems.forEach((item, index) => {
        if (index === 0) {
            item.style.borderTop = "none"
        } else {
            item.style.borderTop = "1px solid #292929"
        }
    })
}

// Add logic to the favorite button
document.querySelectorAll(benefitFavoriteButtonClass).forEach((container) => {
    createFavoriteButton(container)
})

// Add event listener to the feed items to redirect on click
document.querySelectorAll(benefitFavoriteFeedClass).forEach((container) => {
    container.addEventListener("click", (element) => {
        const link = container.querySelector("a")
        window.location.href = link.getAttribute("href")
    })
})

updateFeedBorders()
